import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Popover, Table, TableCell, TableBody, TableHead, TableRow, Typography } from '@material-ui/core';
import { FilesDropzone, Alert } from 'components';
import { enqueueSnackbar } from 'actions';
import uuid from 'uuid/v1';

import { Upload } from '../actions/ImportActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	paper: {
		padding: theme.spacing(1),
	},
	popover: {
		pointerEvents: 'none',
	},
}));

const acceptedFiles = [
	{ type: 'Voice failures', filename: '*voice*', fileformat: '.csv' },
	{ type: 'Packet failures', filename: '*packet*', fileformat: '.csv' },
];

const Import = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const _upload = (file) => {
		if (file[0].size > 100000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 100MB', options: { variant: 'warning' } }));
			return;
		}

		dispatch(Upload(file[0]));
	};

	return (

		<div className={clsx(classes.container)}>
			<Alert
				variant="info"
				message="Accepted Files"
				aria-owns={open ? 'mouse-over-popover' : undefined}
				aria-haspopup="true"
				onMouseOver={handlePopoverOpen}
				onMouseLeave={handlePopoverClose}
			/>
			<Card className={classes.container}>
				<CardContent>
					<FilesDropzone
						multiple={false}
						acceptedTypes=".zip"
						upload={_upload}
					/>
				</CardContent>
			</Card>
			<Popover
				id="mouse-over-popover"
				className={classes.popover}
				classes={{
					paper: classes.paper,
				}}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
			>
				<Table aria-label="simple table">
					<TableHead>
						<TableRow>
							<TableCell>Type</TableCell>
							<TableCell>File Name</TableCell>
							<TableCell>File Format</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{acceptedFiles.map((row) => (
							<TableRow key={uuid()}>
								<TableCell component="th" scope="row">
									{row.type}
								</TableCell>
								<TableCell>{row.filename}</TableCell>
								<TableCell>{row.fileformat}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Popover>
		</div>
	);
};

export default Import;
